import { VFC } from 'react';
import { DialogContent, Dialog } from '@mui/material';
import PaymentForm from '../PaymentForm/PaymentForm';
import logo from 'assets/images/engarde-logo.svg';

const PaymentModal: VFC<{
  onClose: () => void;
  products: any[];
}> = ({ onClose, products }) => {
  return (
    <Dialog open={true} onClose={onClose} maxWidth="md" scroll="body">
      <DialogContent className="pt-6 px-0 pb-0 flex items-center overflow-hidden flex-col min-w-[340px] min-h-[355px]">
          <img src={logo} className="my-2 h-14 w-14" alt="Engarde logo" />
          <PaymentForm products={products} />
      </DialogContent>
    </Dialog>
  );
};

export default PaymentModal;
